import { useState, useEffect, ReactNode } from 'react';

import { Tooltip, IconButton } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import TextLink from 'components/text-link';
import { EMPTYDATA } from 'components/utils/constants';

import { useStyles } from './copyable-text.styles';

const CopyableText = ({
  annotation,
  text,
  linkTo,
}: {
  annotation: string;
  text?: ReactNode;
  linkTo?: string;
}) => {
  const classes = useStyles();
  const [justClickedCopy, setJustClickedCopy] = useState(false);

  useEffect(() => {
    if (justClickedCopy) {
      const timeout = setTimeout(() => setJustClickedCopy(false), 3000);
      return () => clearTimeout(timeout);
    }
  }, [justClickedCopy]);

  if (typeof text === 'string') {
    const truncatedText = (
      <span className={classes.text} translate="no">
        {text}
      </span>
    );

    return (
      <div className={classes.wrapper}>
        <span className={classes.textContainer}>
          {linkTo ? <TextLink to={linkTo}>{truncatedText}</TextLink> : truncatedText}
        </span>
        <span className={classes.buttonWrapper}>
          <CopyToClipboard text={text}>
            <IconButton
              size="small"
              className={classes.iconButton}
              aria-label={`Copy ${annotation}`}
              onClick={() => setJustClickedCopy(true)}
            >
              <Tooltip
                title={justClickedCopy ? 'Copied to Clipboard!' : `Copy ${annotation}`}
                arrow
              >
                <FileCopy className={classes.icon} aria-hidden="true" />
              </Tooltip>
            </IconButton>
          </CopyToClipboard>
        </span>
      </div>
    );
  }
  return <>{EMPTYDATA}</>;
};

export default CopyableText;
